export default {
  set(style, key, value) {
    style[key] = value;
  },
};



// WEBPACK FOOTER //
// ./src/components/common/calendar/autoPrefix.js